import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview, getPostHog } from "@/lib/analytics";

export function usePostHogPageviews() {
  const location = useLocation();
  useEffect(() => {
    if (!getPostHog()) return;
    capturePageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
}